import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaCamera, FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaWhatsapp, FaArrowUp } from 'react-icons/fa';
import IconWrapper from './IconWrapper';
import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-content align-items-start">
          <Col lg={4} md={6} className="mb-4">
            <div className="footer-brand">
              <div className="brand-info">
                <IconWrapper icon={FaCamera} className="brand-icon" />
                <span className="brand-text">FajneFotky</span>
              </div>
              <p className="brand-description">
                Profesionální fotografka pro vaše nejdůležitější okamžiky v životě.
                Svatby, portréty, události - vytvořím pro vás nezapomenutelné vzpomínky.
              </p>
              <div className="social-links">
                <a href="https://www.facebook.com/fajnefotky/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <IconWrapper icon={FaFacebook} />
                </a>
                <a href="https://www.instagram.com/ivanabuzkova/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <IconWrapper icon={FaInstagram} />
                </a>
                <a href="https://wa.me/421905123456" target="_blank" rel="noopener noreferrer" className="social-link">
                  <IconWrapper icon={FaWhatsapp} />
                </a>
              </div>
            </div>
          </Col>

          <Col lg={2} md={6} className="mb-4">
            <h5 className="footer-title">Služby</h5>
            <ul className="footer-links">
              <li><Link to="/services">Svatební fotografie</Link></li>
              <li><Link to="/services">Rodinné foto</Link></li>
              <li><Link to="/services">Vánoční focení</Link></li>
              <li><Link to="/services">Firemní focení</Link></li>
            </ul>
          </Col>

          <Col lg={2} md={6} className="mb-4">
            <h5 className="footer-title">Stránky</h5>
            <ul className="footer-links">
              <li><Link to="/">Domů</Link></li>
              <li><Link to="/services">Služby</Link></li>
              <li><Link to="/gallery">Galerie</Link></li>
              <li><Link to="/contact">Kontakt</Link></li>
            </ul>
          </Col>

          <Col lg={4} md={6} className="mb-4 footer-contact">
            <div className="contact-block">
              <h5 className="footer-title">Kontakt</h5>
              <div className="contact-info">
                <div className="contact-item">
                  <IconWrapper icon={FaPhone} className="contact-icon" />
                  <a
                    href="tel:+420725121408"
                    className="contact-link"
                    aria-label="Zavolat +420 725 121 408"
                  >
                    +420&nbsp;725&nbsp;121&nbsp;408
                  </a>
                </div>
                <div className="contact-item">
                  <IconWrapper icon={FaEnvelope} className="contact-icon" />
                  <a
                    href="mailto:ivanabuzkova@seznam.cz"
                    className="contact-link"
                    aria-label="Poslat email na ivanabuzkova@seznam.cz"
                  >
                    ivanabuzkova@seznam.cz
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="footer-bottom">
          <Row className="align-items-center">
            <Col md={6}>
              <p className="copyright">
                ©{currentYear} FajneFotky. Všechna práva vyhrazena.
              </p>
            </Col>
            <Col md={6} className="text-md-end">
              <button onClick={scrollToTop} className="scroll-to-top">
                <IconWrapper icon={FaArrowUp} />
              </button>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
